module.exports = __webpack_public_path__ + "img/notice-modal-es-ES.68229f88.png";